import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useAuthStore } from '@/core/stores/auth'
import { TremorLogo } from '@/shared/components/ui/TremorLogo'

export function AuthCallback() {
  const [params] = useSearchParams()
  const { login } = useAuthStore()
  const navigate = useNavigate()

  useEffect(() => {
    const token = params.get('token')
    if (token) {
      login(token).then(() => {
        navigate('/home', { replace: true })
      })
    } else {
      navigate('/login', { replace: true })
    }
  }, [params, login, navigate])

  return (
    <div className="min-h-screen flex items-center justify-center bg-paper">
      <div className="flex flex-col items-center gap-4">
        <TremorLogo size={40} className="text-gold animate-pulse" />
        <p className="text-sm text-ink-muted font-medium">Connexion en cours…</p>
      </div>
    </div>
  )
}
